export function isNativeLoginCancellation(error: unknown): boolean {
    try {
        if (!(error instanceof Error)) return false;
        return error.message === 'Login cancelled' || error.message === 'Native login cancelled' || error.message === 'Login replaced' || (error as Error & { code?: unknown }).code === 'CANCELLED';
    } catch { return false; }
}
